<template>
    <div class="second-tab">
        <div class="second-tab-wrap">
            <div class="cell-wrap">
                <div @click="switchTab(index)" class="second-tab-cell" v-for="(item, index) in barData" :key="index"
                    :class="[{ active: currentTab === index }]" :id="`second-tab-cell${index}`">
                    <p :id="`second-tab-text${index}`">{{ item.title }}</p>
                </div>
            </div>
            <div class="target-wrap">
                <div class="resource-center-switch" id="float-target"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'secondTab',
    props: {
        barData: {
            type: Array,
            default: () => [{
                title: '资源中心',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }, {
                title: '资源中心2',
            }]
        },
    },
    data() {
        return {
            currentTab: 0,
        };
    },
    mounted() {
        if (this.barData && this.barData.length > 0) {
            this.moveTarget(0)
        }
    },
    methods: {
        switchTab(index) {
            this.moveTarget(index)
            let targetEl = document.getElementById(`second-tab-cell${index}`)
            //移动到父元素横向中间
            targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            })
            this.currentTab = index
            this.$emit('switchTab', index)
        },
        moveTarget(index) {
            let el = document.getElementById(`second-tab-text${index}`)
            let targetEl = document.getElementById('float-target')
            //点击后把float-target横向移动到点击的元素下面，考虑到元素本身的宽度和targetEl的宽度
            targetEl.style.left = el.offsetLeft + (el.offsetWidth - targetEl.offsetWidth) / 2 + 'px'
        },
    },
};
</script>

<style lang='scss' scoped>
.second-tab {
    margin-bottom: .1rem;
    user-select: none;
    cursor: pointer;
    overflow-x: hidden;
    overflow-y: auto;

    &-wrap {
        .cell-wrap {
            display: flex;
            align-items: center;
            position: relative;

            .second-tab-cell {
                flex-shrink: 0;
                margin-right: .2rem;

                p {
                    font-size: .22rem;
                }

                &.active {
                    font-weight: bold;
                }
            }
        }

        .target-wrap {
            margin-top: .05rem;
            position: relative;

            .resource-center-switch {
                position: relative;
                left: 0;
                transition: all .5s;
            }
        }
    }
}
</style>